import { FC, PropsWithChildren, useEffect } from 'react';
import {
  CoreContext,
  defaultCoreContext,
} from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';
import {
  BrandAffinityInsightsCoreContextVars,
  BrandAffinityInsightData,
  BrandAffinityInsightResponse,
} from 'modules/intelligentInsights/brandAffinityInsights/types';
import { TimespanEnum } from 'modules/intelligentInsights/types';
import { useLazyGraphql } from 'utils/hooks/useLazyGraphql';
import { useBrandAffinityInsightsSearchParams } from 'modules/intelligentInsights/brandAffinityInsights/hooks/useBrandAffinityInsightsSearchParams';
import { isEmpty } from 'lodash';
import { fetchBAReporting } from 'modules/intelligentInsights/brandAffinityInsights/graphql/fetchBAReporting';
import { createCoreFetchVars } from 'modules/intelligentInsights/domain.utils';

export const CoreContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { fetch, isLoading, error, data } = useLazyGraphql<
    BrandAffinityInsightResponse,
    BrandAffinityInsightsCoreContextVars
  >(fetchBAReporting, {
    notifyOnNetworkStatusChange: true,
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies:
  useEffect(() => {
    fetch(createCoreFetchVars(TimespanEnum.Thirty));
  }, []);

  const dataLoaded = !isEmpty(data);
  const { selectedTab, setSelectedTab } = useBrandAffinityInsightsSearchParams();

  let isReady = false;
  isReady = !isLoading && !error && dataLoaded;
  return (
    <CoreContext.Provider
      value={{
        insightsData: isEmpty(data)
          ? defaultCoreContext.insightsData
          : (data?.brandAffinityReporting as BrandAffinityInsightData),
        isLoading,
        isError: error,
        isReady,
        fetchCoreData: (nextTimespan: TimespanEnum) => fetch(createCoreFetchVars(nextTimespan)),
        selectedAffinityTab: selectedTab,
        setSelectedAffinityTab: setSelectedTab,
      }}
    >
      {children}
    </CoreContext.Provider>
  );
};
